<template>
  <body class="focus-body">
    <div class="text-wrapper">
      <TextLabel labelColor="white" labelText="Decoupled Growth" />
      <div class="title">Wecobi’s Focus on Decoupled Growth</div>
      <div class="text">
        At Wecobi, we believe that business growth should not come at the
        expense of the environment. Traditional business models often tie growth
        to increased production, which can lead to overproduction, waste, and a
        significant environmental footprint. Wecobi challenges this paradigm by
        promoting decoupled growth—a model where businesses can scale and thrive
        without proportional increases in resource consumption or environmental
        impact.
      </div>
    </div>
  </body>
</template>

<script>
import TextLabel from "./ReusableComponents/TextLabel.vue";

export default {
  name: "Focus",
  components: {
    TextLabel,
  },
};
</script>

<style scoped>
.focus-body {
  width: 100%;
  height: 790px;
  background-image: url("../../../assets/sustainability/Focus.png");
  background-position: 0 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 20px;
}

.text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-left: 120px;
}
.title {
  font-size: 50px;
  font-weight: 600;
  line-height: 1.2;
}
.text {
  font-size: 16px;
  font-weight: 400;
}
.title,
.text {
  max-width: 606px;
  color: #ffffff;
}
@media (max-width: 1024px) {
  .focus-body {
    height: 630px;
  }
  .text-wrapper {
    margin-left: 90px;
  }
  .title {
    font-size: 40px;
  }
  .text {
    font-size: 14px;
  }
  .title,
  .text {
    max-width: 463px;
  }
}
@media (max-width: 744px) {
  .focus-body {
    height: 530px;
  }
  .text-wrapper {
    margin-left: 60px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 588px) {
  .focus-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .text-wrapper {
    margin-left: 0px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
  .title,
  .text {
    max-width: 450px;
  }
}
@media (max-width: 431px) {
  .focus-body {
    height: 512px;
  }
  .title {
    font-size: 25px;
  }
  .title,
  .text {
    max-width: 300px;
  }
}
</style>
